module.exports = __webpack_public_path__ + "static/media/footer-1-2.ac379796.png";